import { getLocale } from '@lwtears/lwt-common-frontend/lib/@common/util';
import LwtApi, { AuthStrategy } from '@lwtears/lwt-common-frontend/lib/@common/util/api-util';
import { Header } from '@lwtears/lwt-common-frontend/lib/@common/util/header-util';

const getHeaders = () => ({ [Header.LOCALE]: getLocale() });

export const getApi = (authStrategy: AuthStrategy = AuthStrategy.AUTH_TOKEN) =>
  LwtApi()
    .addDefaultAuthStrategy(authStrategy)
    .options({ throwErrors: true })
    .addHeaders(getHeaders);

export * from './user';
export * from './telemetry';
